import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'

type IProps = {
  children: ReactNode;
}

type DashboardContextProps = {
  sidebarIsOpen: boolean;
  onToggleSidebar: () => void;
  windowWidth: number;
}

const DashboardContext = createContext({} as DashboardContextProps)

const DashboardProvider = ({ children }: IProps): JSX.Element => {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  function toggleSidebar() {
    setSidebarIsOpen(!sidebarIsOpen)
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <DashboardContext.Provider
      value={{
        sidebarIsOpen,
        onToggleSidebar: toggleSidebar,
        windowWidth,
      }}
    >
      {children}
    </DashboardContext.Provider>
  )
}

export const useDashboard = () => {
  const context = useContext(DashboardContext)

  if (!context) {
    throw new Error('useDashboard must be used within a provider DashboardProvider')
  }

  return context
}

export default DashboardProvider
